import React, { useState } from 'react';
import styles from '../styles/components/GrantAccessForm.module.css';
import {load_fetch} from "../pr_utils";

const GrantAccessForm = ({ person, availableRoles, closeForm }) => {
    const [username, setUsername] = useState(person.email || '');
    const [password, setPassword] = useState('');
    const [selectedRoles, setSelectedRoles] = useState([]);

    // Ajax Functions
    const generatePassword = () => {
        load_fetch("Security_Handler.php", {operation: 'GENERATE_PASSPHRASE'}, (data) => {
            if (!data.ERROR && data.DATA) {
                setPassword(data.DATA);
            } else {
                console.log("Failed to generate passphrase.", data);
            }
        })
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!Object.values(passwordChecks).every(Boolean)) {
            return;
        }

        let formData = {};
        formData.person_id = person.person_id;
        formData.username = username;
        formData.password = password;
        formData.roles = selectedRoles;
        formData.operation = "GRANT_LOGIN_ACCESS";

        load_fetch("Security_Handler.php", formData, (data) => {
            if(!data.SUCCESS) {
                console.log(data);
            } else {
                closeForm();
            }
        })
    };


    // Other Functions
    const handleRoleToggle = (role) => {
        setSelectedRoles((prev) =>
            prev.includes(role)
                ? prev.filter((r) => r !== role)
                : [...prev, role]
        );
    };



    const passwordChecks = {
        length: password.length >= 8,
        number: /\d/.test(password),
        special: /[!@#$%^&*-]/.test(password),
    };



    return (
        <form className={styles.grant_access_form} onSubmit={handleSubmit}>
            <div>
                <label>Username (email):</label>
                <input type="text" value={username} onChange={(e) => setUsername(e.target.value)} readOnly />
            </div>
            <div>
                <label>Password:</label>
                <input
                    type="text"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                />
                <button type="button" className={styles.generate_button} onClick={generatePassword}>
                    Generate Password
                </button>
            </div>
            <div className={styles.password_requirements}>
                <div className={passwordChecks.length ? styles.valid : styles.invalid}>
                    Minimum 8 characters
                </div>
                <div className={passwordChecks.number ? styles.valid : styles.invalid}>
                    At least one number
                </div>
                <div className={passwordChecks.special ? styles.valid : styles.invalid}>
                    At least one special character (!@#$%^&*)
                </div>
            </div>
            <div className={styles.roles_container}>
                <div>
                    <label><input type="checkbox" checked={selectedRoles.includes('ADMIN')} onChange={() => handleRoleToggle('ADMIN')} /> ADMIN</label>
                </div>
                <div>
                    <label><input type="checkbox" checked={selectedRoles.includes('DIRECTORY_EDITOR')} onChange={() => handleRoleToggle('DIRECTORY_EDITOR')} /> DIRECTORY_EDITOR</label><br />
                    <label><input type="checkbox" checked={selectedRoles.includes('DIRECTORY_VIEWER')} onChange={() => handleRoleToggle('DIRECTORY_VIEWER')} /> DIRECTORY_VIEWER</label>
                </div>
                <div>
                    <label><input type="checkbox" checked={selectedRoles.includes('SERVICE_EDITOR')} onChange={() => handleRoleToggle('SERVICE_EDITOR')} /> SERVICE_EDITOR</label><br />
                    <label><input type="checkbox" checked={selectedRoles.includes('SERVICE_VIEWER')} onChange={() => handleRoleToggle('SERVICE_VIEWER')} /> SERVICE_VIEWER</label>
                </div>
            </div>
            <button type="submit" className={styles.submit_button} disabled={!Object.values(passwordChecks).every(Boolean)}>
                Grant Access
            </button>
        </form>
    );
};

export default GrantAccessForm;
